/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.NSP.Title',
    defaultMessage: 'NSP',
  },
});

export default messages;
